import React from 'react'
import styled from 'styled-components'

import { DiscoverMore, H2, Screen, Section } from 'ui'

const Container = styled(Section.White) `
  padding-top: 105px;
  padding-bottom: 105px;

  @media screen and (max-width: 640px) {
    padding-top: 100px;
    padding-bottom: 120px;
  }
`

const InnerContainer = styled(Screen) `
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled(H2) `
  margin: 0px 0px 90px 0px;

  @media screen and (max-width: 640px) {
    margin-bottom: 60px;
  }
`

const Text = styled.p `
  line-height: calc(18px + 22px);
  margin: 0px;
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 1px;
  text-align: center;

  @media screen and (max-width: 640px) {
    line-height: 36px;
  }
`

const About = () => (
  <Container>
    <InnerContainer>
      <Title>
        Creative Direction,<br />
        Marketing and Communication specialist helping achieve your greatness
      </Title>
      <Text>
        Expert in Creative Direction and Visual Design,<br />
        he is active in the field of marketing strategies with a keen focus on all aspects related to brand development and communication.
      </Text>
      <Text>
        During fifteen years of experience, he has developed multidisciplinary hard and soft skills for the design of assets, development of the brand equity and communication on behalf of Italian and international companies, held the role of Creative Director for agencies specializing in the design, luxury, branding, editorial, web-digital, events and consultant for communications on behalf of structured companies.
      </Text>
      <Text>
        He received numerous awards including the Honorable Mention at the XX Compasso D’oro ADI Award in 2004.
      </Text>
      <DiscoverMore />
    </InnerContainer>
  </Container>
)

export default About
